import { AxiosResponse } from 'axios';
import { instance as axios } from 'api/axios';
import { format } from 'date-fns';

import { clientDateFormat } from '../../../../entities/Trip';
import { SecurityReport2359 } from './interfaces';

export class SecurityReport2359Service {
  public static async getReports(branchId: string) {
    try {
      const url = '/Reports/report2359';
      const response: AxiosResponse<SecurityReport2359[]> = await axios.get(url, {
        params: {
          branchId,
        },
      });

      return response.data.reverse();
    } catch (error: any) {
      throw error.response;
    }
  }

  public static formatReportForTable(reports: SecurityReport2359[]): SecurityReport2359[] {
    return reports.map((report) => {
      const currentStatusSetDt =
        report.currentStatusSetDt === null ? '' : format(new Date(report.currentStatusSetDt), clientDateFormat);
      const arrivalDate = report.arrivalDate === null ? '' : format(new Date(report.arrivalDate), clientDateFormat);

      return {
        ...report,
        currentStatusSetDt,
        arrivalDate,
      };
    });
  }
}
